export default __webpack_public_path__ + "static/media/logo.a41cf552.png";